import { render, staticRenderFns } from "./MatchingStep.vue?vue&type=template&id=2465fdfa&scoped=true"
import script from "./MatchingStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./MatchingStep.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MatchingStep.vue?vue&type=style&index=0&id=2465fdfa&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465fdfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2465fdfa')) {
      api.createRecord('2465fdfa', component.options)
    } else {
      api.reload('2465fdfa', component.options)
    }
    module.hot.accept("./MatchingStep.vue?vue&type=template&id=2465fdfa&scoped=true", function () {
      api.rerender('2465fdfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/MatchingStep.vue"
export default component.exports